import { AnimatePresence, motion } from 'framer-motion'
import * as TWEEN from '@tweenjs/tween.js'
import { ChangeEvent, useEffect, useState } from 'react'
import { Object3D } from 'three'

import s from './LetterConfigurator.module.scss'
import { animateChangeMeshes } from '../../utils/animate-change-meshes'
import { TOpacityOption } from '../../utils/animate-change-meshes'
import { ANIMATION_DURATION } from '../../../viewerSettings'

export const LetterConfigurator = ({ model }: { model: Object3D | undefined }): JSX.Element => {
  const [currentLetter, setCurrentLetter] = useState('A')
  const [prevLetter, setPrevLetter] = useState('')

  const letters = 'ABC'.split('')

  let tweenOut: TWEEN.Tween<TOpacityOption>
  let tweenIn: TWEEN.Tween<TOpacityOption>

  function changeLetter(model: Object3D, currentIndex: number, prevIndex: number) {
    if (tweenIn) TWEEN.remove(tweenIn)
    if (tweenOut) TWEEN.remove(tweenOut)
    for (const group of model.children) {
      const prevMeshes: Array<Object3D> = []
      const currentMeshes: Array<Object3D> = []

      for (const mesh of group.children) {
        letters.forEach((letter, index) => {
          if (mesh.name.includes(`_${letter}`)) {
            mesh.visible = false
            if (prevIndex > -1 && index === prevIndex) {
              prevMeshes.push(mesh)
            } else if (index === currentIndex) {
              currentMeshes.push(mesh)
            }
          }
        })
      }

      if (prevIndex > -1) {
        animateChangeMeshes(prevMeshes, 0, 'out')
      }
      animateChangeMeshes(currentMeshes, prevIndex > -1 ? ANIMATION_DURATION : 0, 'in')
    }
  }

  const handleSelectLetter = (event: ChangeEvent<HTMLSelectElement>) => {
    setPrevLetter(currentLetter)
    setCurrentLetter(event.target.value)
  }

  function onChange(model: Object3D, currentLetter: string, prevLetter: string) {
    changeLetter(model, letters.indexOf(currentLetter), letters.indexOf(prevLetter))
  }

  useEffect(() => {
    if (!model) return

    onChange(model, currentLetter, prevLetter)
  }, [currentLetter])

  return (
    <AnimatePresence mode="wait">
      <motion.select
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        value={currentLetter}
        onChange={handleSelectLetter}
        className={s.LetterConfigurator}
        key={'select-letter'}
      >
        {letters.map((letter, key) => {
          return (
            <option key={`letter-${key}`} value={letter}>
              {letter}
            </option>
          )
        })}
      </motion.select>
    </AnimatePresence>
  )
}
